import React, { useMemo, useState } from 'react'
import AutoSelect, { AutoSelectProps } from '../AutoSelect'
import {
  ResponseWorkflowDto,
  useGetWorkflowsListQuery
} from '../../../store/api/workflows'

export type WorkflowsSelectProps = Pick<
  AutoSelectProps<ResponseWorkflowDto>,
  'value' | 'onChange'
>

export default ({ ...props }: WorkflowsSelectProps) => {
  const [searchValue, setSearchValue] = useState<string>()

  const args = useMemo(
    () => ({
      ...(searchValue && { name: searchValue }),
      limit: 10
    }),
    [searchValue]
  )

  const { data, isFetching } = useGetWorkflowsListQuery(args)

  return (
    <AutoSelect
      options={data?.items ?? []}
      isOptionEqualToValue={(option, value) => option.id === value?.id}
      onSearchChange={setSearchValue}
      loading={isFetching}
      getOptionLabel={o => o.name}
    />
  )
}
